import t from '@jetshop/intl';
import React from 'react';
import { styled } from 'linaria/react';

const StyledTitle = styled('h1')`
    align-items: center;
    justify-content: center;
    display: flex;
  `

export const Main3DTitle = () => {
  return <StyledTitle>{t('Designa din soffa')}</StyledTitle>
}